import { useMemo } from "react";
import { useAppSelector } from "./hooks";

export const useDefaultsKubernetesValuesConvertor = () => {
  const defaultsKubernetesValues = useAppSelector(
    (state) => state.app.config.defaultsKubernetesValues
  );

  const cpuStringToNumber = (value: string) => {
    const regex = /^[0-9]+m$/;
    if (regex.test(value)) {
      const numberValue = value.replace("m", "");
      return Number(numberValue);
    } else {
      return null;
    }
  };

  const memoryStringToNumber = (value: string) => {
    const regex = /^[0-9]+Mi$/;
    if (regex.test(value)) {
      const numberValue = value.replace("Mi", "");
      return Number(numberValue);
    } else {
      return null;
    }
  };

  const memoryMax = useMemo(() => {
    if(defaultsKubernetesValues?.memoryMax) {
      const memoryNumber = memoryStringToNumber(defaultsKubernetesValues?.memoryMax);

      if (memoryNumber !== null) {
        return memoryNumber;
      }
    }
    return 8000
  },[defaultsKubernetesValues?.memoryMax])


  const cpuMax = useMemo(() => {
    if(defaultsKubernetesValues?.cpuMax) {
      const cpuNumber = cpuStringToNumber(defaultsKubernetesValues?.cpuMax);

      if (cpuNumber !== null) {
        return cpuNumber/1000;
      }
    }
    return 4
  },[defaultsKubernetesValues?.cpuMax])


  const cpuMin = useMemo(() => {
    if(defaultsKubernetesValues?.cpuMin) {
      const cpuNumber = cpuStringToNumber(defaultsKubernetesValues?.cpuMin);

      if (cpuNumber !== null) {
        return cpuNumber/1000;
      }
    }
    return 0.1
  },[defaultsKubernetesValues?.cpuMin])

  const memoryMin = useMemo(() => {
    if(defaultsKubernetesValues?.memoryMin) {
      const memoryNumber = memoryStringToNumber(defaultsKubernetesValues?.memoryMin);

      if (memoryNumber !== null) {
        return memoryNumber;
      }
    }
    return 128
  },[defaultsKubernetesValues?.memoryMin])

  return {
    cpuMin,
    memoryMin,
    cpuMax,
    memoryMax
  };
};
